import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import { Lock } from 'lucide-react';

const AdminLogin = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success('Bem-vindo!');
      navigate('/admin');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Erro ao fazer login');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAF8F5] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img
            src="/images/logo.png"
            alt="Petiscaria Camamu"
            className="h-32 w-32 mx-auto mb-4"
            data-testid="login-logo"
          />
          <h1
            className="text-3xl font-bold text-[#291014]"
            style={{ fontFamily: 'Outfit, sans-serif', letterSpacing: '-0.02em' }}
            data-testid="login-title"
          >
            Painel Admin
          </h1>
          <p className="text-[#5C4247] mt-2" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Petiscaria Camamu
          </p>
        </div>

        <form onSubmit={handleSubmit} className="bg-white rounded-2xl p-8 border border-[#F3E8E3] shadow-lg">
          <div className="flex items-center gap-2 mb-6">
            <Lock className="h-5 w-5 text-[#7F1D1D]" />
            <h2 className="text-xl font-bold text-[#291014]" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Acesso Restrito
            </h2>
          </div>

          <div className="space-y-4">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="mt-1"
                data-testid="login-email-input"
              />
            </div>
            <div>
              <Label htmlFor="password">Senha</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="mt-1"
                data-testid="login-password-input"
              />
            </div>
          </div>

          <Button
            type="submit"
            disabled={loading}
            className="w-full mt-6 bg-[#7F1D1D] hover:bg-[#991B1B] text-white font-semibold py-6 rounded-full"
            data-testid="login-submit-button"
          >
            {loading ? 'Entrando...' : 'Entrar'}
          </Button>
        </form>

        <div className="text-center mt-6">
          <a href="/" className="text-sm text-[#5C4247] hover:text-[#7F1D1D]" data-testid="back-to-site-link">
            ← Voltar ao site
          </a>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
